import {Select} from "antd";
import React from "react";
import {connect} from "react-redux";
import {currentEffectiveUserId} from "../../reducers/ui";
import {compose} from "redux";
import {withTransparentLoading} from "./deferLoaderHoc";
import {getCompanyEmployees} from "../../actions/companies";
import {emulateUser} from "../../actions/ui";
import {nameSort} from "../../common/sorters";
import {UserCustomNoPopover} from "./UserCustomNoPopover";
import Spinner from "react-spinkit";
import UserSmall from "./UserSmall";

function EmulateControl(props) {
  const handleSelect = (userId) => props.onEmulate && props.onEmulate(userId);
  const employees = Object.values(props.employees);
  employees.sort((a, b) => nameSort(a, b));
  return <div
    style={{
      position: 'absolute',
      top: 143,
      right: 0,
      width: 300,
      height: 25,
      display: 'flex',
      alignItems: 'center'
    }}>
    {props.profile.companyadmin ?
      <React.Fragment>
        <span style={{ marginRight: 5 }}>Viewing as:</span>
        <Select size='small' style={{ width: 180 }} value={props.effectiveUser} onSelect={handleSelect}>
          {employees.length ?
            employees.map(employee =>
              <Select.Option value={employee.id}>
                <UserCustomNoPopover id={employee.id} dataPath={['employees']}/>
              </Select.Option>) :
            <Select.Option value={props.effectiveUser}>
              <Spinner style={{ height: 20 }} name='line-scale'/>
            </Select.Option>
          }
        </Select>
      </React.Fragment> :
      <React.Fragment>
        <span style={{ marginRight: 8 }}>Logged in as:</span>
        <UserSmall id={props.effectiveUser}/>
      </React.Fragment>
    }
  </div>;
}

export default compose(
  connect(
    (state, props) => ({
      employees: state.employees,
      effectiveUser: currentEffectiveUserId(state),
      profile: state.profile
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyEmployees()),
      onEmulate: userId => dispatch(emulateUser(userId)),
    }),
  ),
  withTransparentLoading
)(EmulateControl)



// WEBPACK FOOTER //
// ./src/components/Boilerplate/EmulateControl.js